module.exports = __webpack_public_path__ + "img/brushes-cn-1.3df2d12.jpg";